import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {IAddress, IOrderDetail} from "../models/IOrderDetail";
import {translateFunction} from "../../../localization/TranslationService";

const translate = translateFunction("SureBasePortalOrders");

function createData(
	name: string,
	value: string | null | undefined,
) {
	if (!value)
		value = "";
	name = translate(name);
	return {name, value};
}

const StyledTableCell = styled(TableCell)(({theme}) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

function getGetAddress(address: IAddress | null | undefined): string {
	if (!address)
		return "";
	
	return address.houseNumber + (address.houseNumberAddition ?? "") + (address.houseLetter ?? "") + " " + (address.street ?? "") + "," + (address.postalCode ?? "");
	
}

export function HouseBuildingData(props: { order: IOrderDetail }) {
	if (!props.order.policyId || !props.order.package?.policyDetails)
		return (<div></div>);
	const order = props.order;
	const rows: { name: string; value: string | null | undefined }[] = [];
	
	const house = order.houseInformation;
	
	rows.push(createData("Construction year", house?.constructionYear?.toString()));
	rows.push(createData("Home type", translate(house?.homeType?.toString())));
	rows.push(createData("Property of insured", house?.propertyOfInsured?.toString()));
	rows.push(createData("Address", getGetAddress(house?.address)));
	return (
		<TableContainer component={Paper}>
			<Table sx={{minWidth: 650}} size="small" aria-label="Health Care">
				<TableBody>
					{rows.map((row) => (
						<StyledTableRow
							key={row.name}
						>
							<StyledTableCell component="th" scope="row">
								{row.name}
							</StyledTableCell>
							<StyledTableCell align="right">{row.value}</StyledTableCell>
						</StyledTableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
	
}
